import { DismissableBanner } from "@/Features/_components/DismissableBanner";
import { LABELS_HELP_URL, PRINT_LABELS_BANNER_ID } from "../labels.constants";

/**
 * What's new in the Print Labels dialog: bulk print from the evidence table,
 * copies per item, and the previews. The same banner in bulk and single item
 * mode, closed once per user in this browser.
 */
export const PrintLabelsBanner: React.FC = () => (
  <DismissableBanner
    id={PRINT_LABELS_BANNER_ID}
    title="You can now print labels for several items at once"
    data-testid="print-labels-banner"
    actions={
      <a
        href={LABELS_HELP_URL}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Learn more about printing labels"
      >
        Learn more
      </a>
    }
  >
    Select items in the evidence table and choose Print Labels from the Actions
    menu. You can set copies per item and preview each label before it prints.
  </DismissableBanner>
);

export default PrintLabelsBanner;
